export default class EdifyHelpers {
  /**
   * controla o toggle do formulario de comentário
   */
  static replyFormShow() {
    const formWrapper = $(".commentform-container");
    const toggler = $(".commentform-toggler");
    const cancelReply = $("#cancel-comment-reply-link");
    const replyLink = $(".comment-reply-link");

    // Oculta / mostra o botao "escrever comentario", no acionamento do
    // collapse do form. Isso e necessario para evitar um bug: acionar o
    // collapse no lugar "errado"
    formWrapper
      .on("shown.bs.collapse", function () {
        toggler.fadeOut();
      })
      .on("hidden.bs.collapse", function () {
        toggler.fadeIn();
      });

    replyLink.on("click", function () {
      $(this).addClass("disabled");
      formWrapper.collapse("show");
    });

    cancelReply.on("click", function () {
      replyLink.removeClass("disabled");
      formWrapper.collapse("hide");
    });
  }

  /**
   * Fixa o menu principal no topo no scroll
   * @param {jquery} element
   */
  static scrolledMenu(mainNavbar) {
    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 0) {
        mainNavbar.addClass('active');
      } else {
        mainNavbar.removeClass('active');
      }
    });
  }

  /**
   * Abre o dropdown quando passar o mouse em um item do menu
   * @param {jquery} element
   */
  static openSubmenuOnHover(mainNavbar) {
    mainNavbar.on('mouseover', '.main-menu .dropdown', function (e) {
      $(this).children('.dropdown-toggle').dropdown('show');
    })
    .on('mouseleave', '.main-menu .dropdown', function (e) {
      setTimeout(() => {
        const hasHover = !$('.dropdown-menu:hover').length;
        if (hasHover) {
          $(this).children('.dropdown-toggle').dropdown('hide');
        }
      }, 300);
    });
  }

  /**
   * Menu mobile
   */

  static activeMobileMenu(mainNavbar) {
    // Botão de menu ativo
    let toggler = $(".navbar-toggler, .btn-menu"),
      collapse = $('.navbar-collapse');

    toggler.on("click", function () {
      $(this).toggleClass("active");
      $("body").toggleClass("menu-opened");

      let status = $(this).hasClass("active") ? "true" : "false";
      $(this).attr("aria-expanded", status);
    });

    mainNavbar.find('a:not(".dropdown-toggle")').on("click", function () {
      collapse.collapse('hide');
    });

    collapse.on('hidden.bs.collapse', function () {
      toggler.removeClass("active");
      $("body").removeClass("menu-opened");
    });
  }

  /**
   * Insere icones no menu
   * @param {string} item
   */
  static insertMenuIcons(menuItem, list) {
    // Icones do menu secundário
    for (let i = 0; i < list.length; ++i) {
      list[i].detach().clone().prependTo(menuItem.eq(i));
    }
  }

  /**
   * Funcionalidade de proximo slider customizada
   */
  static nextSlider(element) {
    const nextElements = document.querySelectorAll(".next-slider");
    nextElements.forEach((next) =>
      next.addEventListener("click", () => {
        const swiper = document.querySelector(element).swiper;
        swiper.slideNext();
      })
    );
  }

  /**
   * Insere pins no mapa
   * @param {jquery} element
   */
  static insertMapPins(element) {
    const blockLocations = element;
    // Mostra as infos quando o mouse esta sobre o pin
    blockLocations
      .find('[data-toggle="collapse"]')
      .on("mouseenter", function () {
        $(this).addClass("active");
        $(this.hash).collapse("show");
      });

    // Esconde as infos quando o mouse sai do pin
    blockLocations.on("mouseleave", function () {
      $(this).find('[data-toggle="collapse"]').removeClass("active");
      $(this).find(".location-info.show").collapse("hide");
    });

    // Ao esconder as infos imediatamente
    blockLocations.find(".location-info").on("hide.bs.collapse", function () {
      let targetId = $(this).attr("id"),
        trigger = `[data-toggle="collapse"][href="#${targetId}"], [data-target="#${targetId}"]`;
      blockLocations.find(trigger).removeClass("active");
    });
  }

  /**
   * Troca os icones do botao caso menu seja aberto ou fechado
   * @param {jquery} element
   */
  static categoryIconsToggle(element) {
    const categoryToggle = element;
    $("#category-nav-mobile")
      .on("show.bs.collapse", function () {
        categoryToggle.children('[name*="caret"]').addClass("d-none");
        categoryToggle.children('[name="close"]').removeClass("d-none");
      })
      .on("hide.bs.collapse", function () {
        categoryToggle.children('[name*="caret"]').removeClass("d-none");
        categoryToggle.children('[name="close"]').addClass("d-none");
      });
  }

  /**
   * Fixa barra de pesquisa fixa na tela
   * @param {jquery} element
   */
  static fixedSearch(element) {
    const fixSearchForm = element;

    fixSearchForm.on("shown.bs.collapse", function () {
      $(this).find("#s").trigger("focus");
    });
    fixSearchForm.find("#s").on("focusout", function () {
      fixSearchForm.collapse("hide");
    });
  }

  /**
   * Remove os banners do Rock Convert que nao estão no post
   */
  // static removeBannersRocket() {
  //   if ($("body").hasClass("single"))
  //     $(":not(.entry-content) > .rock-convert-banner").remove();
  // }

  /**
   * mostra container do spinner de carregamento em um elemento
   * @param {Element} element
   * @param {elementStringHtml} spinner
   */
  static showSpinnerContainer(container, spinner) {
    container.classList.remove("d-none");
    container.innerHTML = spinner;
  }

  /**
   * esconde container do spinner de carregamento
   * @param {Element} container
   */
  static hideSpinnerContainer(container) {
    container.innerHTML = "";
  }

  static saveCheckedTypes(elements) {
    document.addEventListener("DOMContentLoaded", function () {
      var checkbox = document.querySelectorAll(elements);

      for (var item of checkbox) {
        item.addEventListener("click", function () {
          localStorage.s_item // verifico se existe localStorage
            ? (localStorage.s_item =
              localStorage.s_item.indexOf(this.id + ",") == -1 // verifico de localStorage contém o id
                ? localStorage.s_item + this.id + "," // não existe. Adiciono a id no loaclStorage
                : localStorage.s_item.replace(this.id + ",", "")) // já existe, apago do localStorage
            : (localStorage.s_item = this.id + ","); // não existe. Crio com o id do checkbox
        });
      }

      if (localStorage.s_item) {
        // verifico se existe localStorage
        for (var item of checkbox) {
          // existe, percorro as checkbox
          item.checked =
            localStorage.s_item.indexOf(item.id + ",") != -1 ? true : false; // marco true nas ids que existem no localStorage
        }
      }
    });
  }

  static disableCheckbox(checkboxes) {
    checkboxes.forEach((checkbox) => {
      checkbox.setAttribute("disabled", "true");
    });
  }

  static enableCheckbox(checkboxes) {
    checkboxes.forEach((checkbox) => {
      checkbox.removeAttribute("disabled");
    });
  }

  /**
   * Aplica o flexdatalist com os parametros para localizacao
   */
  static datalistLocation(configFlexDataList) {
    const {
      cache,
      delayLoading,
      element,
      groupBy,
      minLength,
      searchDelay,
      searchContain,
      searchIn,
      selectionRequired,
      valueProperty,
      visibleProperties,
      textProperty,
    } = configFlexDataList;

    element.flexdatalist({
      cache,
      groupBy,
      minLength,
      noResultsText: 'Sem resultados para "{keyword}"',
      searchDelay,
      searchContain,
      searchIn,
      selectionRequired,
      valueProperty,
      visibleProperties,
      textProperty,
    });

    // Se houver valor de delay para loading, verifica se o campo de texto do
    // datalist esta sendo preenchido para ativar / desativar o loading
    if (delayLoading) {
      const loadingEl = element.siblings('.form-loading');
      const showStyle = 'd-block';
      let typingTimer;

      $('.flexdatalist-alias').on('keyup', function () {
        clearTimeout(typingTimer);
        loadingEl.addClass(showStyle);

        if (!$(this).val()) return loadingEl.removeClass(showStyle);

        return typingTimer = setTimeout(function () {
          loadingEl.removeClass(showStyle);
        }, delayLoading);
      });
    }
  }

  /**
   * Adiciona / remove classe quando o conteudo do card de produto da Home e exibido / ocultado
   */
  //* Utilizado na secao de produtos da Home que foi desativa por nao ser mais usada
  // static collapseToggleActive(element) {
  //   element
  //     .on("show.bs.collapse", function () {
  //       $(this).parent().addClass("active");
  //     })
  //     .on("hide.bs.collapse", function () {
  //       $(this).parent().removeClass("active");
  //     });
  // }

  /**
   * Aplica o Match Height de forma absoluta
   * (Os elementos terao a mesma altura independente da quantidade de linhas)
   */
  static absoluteMatchHeight(element) {
    element.matchHeight({
      byRow: false,
    });
  }

  /**
   * Habilita o fancybox como modal
   */
  static fancyboxModal(element) {
    element.bind('.modal-toggler', {
      mainClass: "form-message-wrapper",
    });
  }
}

export function removeNofflowLinksAttr(){

  $(document).ready(function() {
    var counter = 0;
    var removeNofollowInterval = setInterval(function() {
      var hasNofollow = $('a[rel*="nofollow"]').length > 0;
      if (hasNofollow) {
        $('a[rel*="nofollow"]').each(function() {
          $(this).attr('rel', $(this).attr('rel').replace('nofollow', '').trim());
        });
      } else if (counter >= 5) { // After 10 seconds (5 intervals of 2 seconds each)
        clearInterval(removeNofollowInterval);
      }
      counter++;
    }, 2000);
  });
  

}